import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "group/tooltip relative cursor-pointer tooltip-container" }
const _hoisted_2 = { class: "tooltip pointer-events-none" }
const _hoisted_3 = {
  key: 0,
  class: "bg-app-gray-100 rounded-t-md py-1 px-2 text-left text-xs text-app-gray-500 font-medium"
}
const _hoisted_4 = {
  key: 1,
  class: "p-2 text-left text-xs text-app-gray-500 font-normal"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
    title: { default: "" },
    details: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true),
      (_ctx.details)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.details), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})